import React, { createContext, useContext, useState, ReactNode } from 'react';

interface DomainTransitionContextType {
	isTransitioning: boolean;
	startTransition: () => void;
	endTransition: () => void;
}

const DomainTransitionContext = createContext<DomainTransitionContextType | undefined>(undefined);

interface Props {
	children: ReactNode;
}

export const DomainTransitionProvider: React.FC<Props> = ({ children }) => {
	const [isTransitioning, setIsTransitioning] = useState(false);

	const startTransition = () => {
		setIsTransitioning(true);
		
		// Safety timeout to ensure transition always ends (fallback)
		setTimeout(() => {
			setIsTransitioning(false);
		}, 2000); // 2 second maximum transition time
	};

	const endTransition = () => {
		setIsTransitioning(false);
	};

	return (
		<DomainTransitionContext.Provider value={{ isTransitioning, startTransition, endTransition }}>
			{children}
		</DomainTransitionContext.Provider>
	);
};

export const useDomainTransitionContext = () => {
	const context = useContext(DomainTransitionContext);
	if (context === undefined) {
		throw new Error('useDomainTransitionContext must be used within a DomainTransitionProvider');
	}
	return context;
};
